import React from 'react'
import Page from 'src/components/page'
import Container from 'src/components/container'
import Section from 'src/components/section'
import Link from 'src/components/link'
import Picture from 'src/components/picture'
import AspectBox from 'src/components/aspect-box'
import RichText from 'src/components/rich-text'
import BoxButton from 'src/components/box-button'

const PressArticlePage = ({ pageContext }) => {
  const { article } = pageContext
  return (
    <Page className="page-press-article">
      <Section className="article-section">
        <Container>
          <div className="article-content">
            <div className="image">
              <AspectBox x={720} y={755}>
                <Picture image={article.image.src} fitWidth cover />
              </AspectBox>
            </div>
            <div className="copy">
              <div className="copy-content">
                <div className="date">{article.date}</div>
                <h3 className="title size-big">{article.title}</h3>
                <RichText className="body">{article.body}</RichText>
                <Link newTab className="more-btn" to={article.fullArticleUrl}>
                  <BoxButton>
                    {article.articleDetailReadMoreButtonText}
                  </BoxButton>
                </Link>
              </div>
            </div>
          </div>
        </Container>
      </Section>
    </Page>
  )
}

export default PressArticlePage
